module.exports = __webpack_public_path__ + "static/media/network.png.ff263532.png";